import { render } from "./Moneda.vue?vue&type=template&id=15a9fcf3&scoped=true"
import script from "./Moneda.vue?vue&type=script&lang=js"
export * from "./Moneda.vue?vue&type=script&lang=js"

import "./Moneda.vue?vue&type=style&index=0&id=15a9fcf3&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-15a9fcf3"

export default script